// @flow
// eslint-disable-next-line import/prefer-default-export
export const STARRED = "starred"
export const RELEASE_NEWS_LAST_CLICKED = "releaseNewLastClicked"
